import React from 'react';
import { autorun } from 'mobx';
import { Provider, observer } from 'mobx-react';
import { RouterStore } from 'mobx-react-router';
import ErrorHandler from './utils/error-handler';
import UserStore from './models/user-store';
import GLMRouter from './glm-router';
import Loader from './components/shared/loader';
import ModalError from './components/guest-list/modals/modal-error';
import { withRouter } from 'react-router-dom';
import ExperimentsStore from './models/experiments-store';
import InitGuestList from './init-guest-list';
import { guestListRoute } from '../helpers/routes';

@withRouter
@observer
class GLMApp extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.userStore = new UserStore();
    this.experimentsStore = new ExperimentsStore();
    this.userStore.initBasicInfo();
    this.routerStore = new RouterStore();
    this.state = { hasError: false, messageType: '' };

    autorun(() => {
      if (this.routerStore.location && this.userStore.isReady) {
        // redirect logged-in users
        const inOnboarding = this.routerStore.location.pathname.match('onboarding');
        const needsOnboarding = !this.userStore.wedding;
        // There is no way this is true
        if (inOnboarding && !needsOnboarding) {
          props.history.push(guestListRoute);
        }
      }
    });
  }

  componentDidMount() {
    const handleErrorCallback = messageType => {
      if (this.routerStore.location.pathname.match('onboarding')) return;
      this.setState({ hasError: true, messageType });
    };
    ErrorHandler.configure(handleErrorCallback);
  }

  closeModal = () => this.setState({ hasError: false, messageType: '' });

  render_app = () => (
    <Provider userStore={this.userStore} experimentsStore={this.experimentsStore} routerStore={this.routerStore}>
      <React.Fragment>
        {this.state.hasError && <ModalError messageType={this.state.messageType} closeModal={this.closeModal} />}
        <InitGuestList>
          <GLMRouter />
        </InitGuestList>
      </React.Fragment>
    </Provider>
  );

  render() {
    return <React.Fragment>{this.userStore.isReady ? this.render_app() : <Loader />}</React.Fragment>;
  }
}

export default GLMApp;
